import {AgentSessionsTokenProvider} from '@github-ui/copilot-auth-token/agent-sessions-token'
// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports
import {makeCAPIRequest, type CAPIRequestOptions} from '@github-ui/copilot-chat/utils/copilot-chat-helpers'
import {getEnv} from '@github-ui/client-env'

const DEFAULT_API_URL = 'https://api.githubcopilot.com'

interface FetchWithAuthOptions {
  path: string
  method?: 'GET' | 'POST' | 'DELETE' | 'PATCH'
  streamingResponse?: boolean
  basePath?: string
  body?: object
}

export class FetchCAPIError extends Error {
  status: number
  constructor(message: string, status: number) {
    super(message)
    this.name = 'FetchCAPIError'
    this.status = status
  }
}

export async function fetchCAPI({
  path,
  method = 'GET',
  streamingResponse = false,
  body,
}: FetchWithAuthOptions): Promise<Response> {
  const tokenProvider = new AgentSessionsTokenProvider()
  const token = await tokenProvider.getAuthToken()

  if (!token) {
    throw new Error('No token available')
  }

  const requestOptions: CAPIRequestOptions = {
    authToken: token,
    basePath: getEnv().copilotApiOverrideUrl ?? DEFAULT_API_URL,
    method,
    path,
    streamingResponse,
    body,
  }
  const response = await makeCAPIRequest(requestOptions)
  if (!response.ok) {
    const errorMessage =
      response.status === 401
        ? 'Unauthorized access - token may be invalid or expired'
        : `Failed CAPI request (${response.status})`
    throw new FetchCAPIError(errorMessage, response.status)
  }
  return response
}
